export default class MaintainRecordDto {
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
id?: any
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
regionId?: any
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
no?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
schoolShortName?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
schoolCode?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
state?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
vehicleNO?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
equipmentCode?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
contactPhone?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
contactBy?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
contactReason?: any | null
/**
 *
 * @type {Array&lt;string&gt;}
 * @memberof MaintainRecordDto
 */
contactReasons?: any | null
/**
 *
 * @type {Date}
 * @memberof MaintainRecordDto
 */
acceptanceTime?: any
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
acceptanceBy?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
acceptanceResult?: any | null
/**
 *
 * @type {Date}
 * @memberof MaintainRecordDto
 */
handleTime?: any
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
handleBy?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
handleType?: any | null
    
maintainRecordType?: any | null;
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
handleResult?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
remark?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
assignBy?: any | null
/**
 *
 * @type {Array&lt;string&gt;}
 * @memberof MaintainRecordDto
 */
assignBys?: any | null
/**
 *
 * @type {Date}
 * @memberof MaintainRecordDto
 */
dispatchTime?: any
/**
 *
 * @type {Array&lt;PartsDto&gt;}
 * @memberof MaintainRecordDto
 */
partsList?: any | null
fileUrls?: any | null
/**
 *
 * @type {string}
 * @memberof MaintainRecordDto
 */
statementBy?: any | null
/**
 *
 * @type {Date}
 * @memberof MaintainRecordDto
 */
completeTime?: any
}
